module.exports = "//img1.rrcimg.com/_next/static/src/assets/xm_2ATtr.png";